import styled from '@emotion/styled';
import { shineOnMe, palette } from '../../css';

const StyledVideoPlaceholder = styled('div')(() => {
    const shineColor = 'rgba(255, 255, 255, .025)';
    return {
        width: '100%',
        paddingBottom: '56.25%',
        ...shineOnMe(shineColor),
        backgroundColor: palette('primary', 'mainNav'),
    };
});

export { StyledVideoPlaceholder };
